/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentFromJSON, FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentToJSON, } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument';
/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocuments interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocuments(value) {
    if (!('Documents' in value) || value['Documents'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentsFromJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentsFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Documents': (json['documents'].map(FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentFromJSON)),
    };
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentsToJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentsToJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'documents': (value['Documents'].map(FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentToJSON)),
    };
}
//# sourceMappingURL=FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocuments.js.map